import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/client";
import { ENDPOINTS } from "@/api/endpoints";
import { InsightByDate } from "@/types/insights.types";

interface GetInsightsByDateParams {
  jobId: string;
  date: string;
}

const getInsightsForJobByPopularStyle = async ({
  jobId,
  date,
}: GetInsightsByDateParams): Promise<InsightByDate[]> => {
  return apiClient
    .get(ENDPOINTS.GET_INSIGHTS_FOR_JOB_BY_POPULAR_STYLE(jobId, date))
    .json<InsightByDate[]>();
};

export const useGetInsightsForJobByPopularStyleQuery = (
  params: GetInsightsByDateParams,
  options?: Omit<
    UseQueryOptions<InsightByDate[], Error>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["jobInsightsByPopularStyle", params.jobId, params.date],
    queryFn: () => getInsightsForJobByPopularStyle(params),
    ...options,
  });
};
